'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _confirmDialog = require('./confirmDialog.component');

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var confirmDialogModule = _angular2.default.module('confirmDialog', [_angularUiRouter2.default]).component('confirmDialog', _confirmDialog2.default).name;

exports.default = confirmDialogModule;


// WEBPACK FOOTER //
// ./client/app/common/confirmDialog/confirmDialog.js